import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  card: {
    height: theme.spacing(24),
    width: theme.spacing(24),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    fontSize: "110%",
    marginTop: theme.spacing(3),
  },
  popOver: {
    minHeight: theme.spacing(175),
    minWidth: theme.spacing(215),
    backgroundColor: theme.palette.secondary.tint90,
    border: `1px solid ${theme.palette.secondary.tint60}`,
    borderRadius: theme.spacing(4),
    boxShadow:
      "0 20px 30px 0 rgba(0, 0, 0, 0.1), 0 30px 30px 0 rgba(0, 0, 0, 0.1)",
    color: theme.palette.secondary.tint15,
    direction: "ltr",
    overflow: "hidden",
  },
  popOverContainer: {
    marginTop: theme.spacing(10),
    marginRight: -theme.spacing(35),
  },
  closeIcon: {
    backgroundColor: theme.palette.red.main,
    borderRadius: "50%",
  },
  popOverText: {
    color: theme.palette.secondary.tint15,
  },
  currencyImage: {
    height: theme.spacing(15),
    width: theme.spacing(15),
  },
  currencyContainer: {
    display: "flex",
    alignItems: "center",
    width: theme.spacing(120),
  },
  currencyText: {
    margin: theme.spacing(0, 3),
  },
  currencySelect: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    width: theme.spacing(150),
  },
}));
